import(/* webpackMode: "eager" */ "/vercel/path0/src/app/artisan-faq/page.tsx");
